export const SNACK_VARIANTS = {
  info: 'info',
  warn: 'warning',
  error: 'error',
  success: 'success',
};

export const DEFAULT_VARIANT_MESSSAGE = 'Unknown error';
